"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ParamParsers_1 = require("../../core/utils/ParamParsers");

var PromotionWeekType_1 = require("../../promotion/enums/PromotionWeekType");

var PromotionStateEnum_1 = require("../../promotion/model/PromotionStateEnum");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var WindowOverviewFilter_1 = require("../model/WindowOverviewFilter");

var WindowSelectEnum_1 = require("../model/WindowSelectEnum");

var WindowStateEnum_1 = require("../model/WindowStateEnum");

var WindowOverviewFilterConverter_1 = require("./WindowOverviewFilterConverter");
/**
 * Default implementation of {@link WindowOverviewFilterConverter}.
 *
 * @author Radek Beran
 */


var WindowOverviewFilterConverterImpl =
/*#__PURE__*/
function (_WindowOverviewFilter) {
  _inherits(WindowOverviewFilterConverterImpl, _WindowOverviewFilter);

  function WindowOverviewFilterConverterImpl() {
    _classCallCheck(this, WindowOverviewFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowOverviewFilterConverterImpl).apply(this, arguments));
  }

  _createClass(WindowOverviewFilterConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowOverviewFilter_1.WindowOverviewFilter(utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'ids')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'filter')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'promotionIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseEnumValue(source, 'promotionWeekType', PromotionWeekType_1.PromotionWeekType)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseEnumValue(source, 'select', WindowSelectEnum_1.WindowSelectEnum)), utils_1.Utils.nullToUndefined(source.simulationsOnly), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'storeSpecifications', StoreSpecificationEnum_1.StoreSpecificationEnum)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'windowTypeIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseList(source, 'promotionTypeIds')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseArrayOfNumbers(source, 'years')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseArrayOfNumbers(source, 'weeks')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'windowWFState', WindowStateEnum_1.WindowStateEnum)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'promotionWFState', PromotionStateEnum_1.PromotionStateEnum)), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'themeId')), utils_1.Utils.nullToUndefined(ParamParsers_1.ParamParsers.parseString(source, 'promotionId')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        ids: utils_1.Utils.mappedValueOrUndefined(source.ids, function (ids) {
          return ids.toArray();
        }),
        filter: source.filter,
        promotionIds: utils_1.Utils.mappedValueOrUndefined(source.promotionIds, function (list) {
          return list.toArray();
        }),
        promotionWeekType: source.promotionWeekType,
        select: source.select,
        simulationsOnly: source.simulationsOnly,
        storeSpecifications: utils_1.Utils.mappedValueOrUndefined(source.storeSpecifications, function (list) {
          return list.toArray();
        }),
        windowTypeIds: utils_1.Utils.mappedValueOrUndefined(source.windowTypeIds, function (list) {
          return list.toArray();
        }),
        promotionTypeIds: utils_1.Utils.mappedValueOrUndefined(source.promotionTypeIds, function (list) {
          return list.toArray();
        }),
        years: source.years,
        weeks: source.weeks,
        windowWFState: utils_1.Utils.mappedValueOrUndefined(source.windowWFState, function (list) {
          return list.toArray();
        }),
        promotionWFState: utils_1.Utils.mappedValueOrUndefined(source.promotionWFState, function (list) {
          return list.toArray();
        }),
        themeId: source.themeId,
        promotionId: source.promotionId
      });
      return result;
    }
  }]);

  return WindowOverviewFilterConverterImpl;
}(WindowOverviewFilterConverter_1.WindowOverviewFilterConverter);

exports.WindowOverviewFilterConverterImpl = WindowOverviewFilterConverterImpl;